import { DEFAULT_GROUP_MIN_QUANTITY } from '../Pricing.constants';

export const getGroupMinimumQuantity = (minimumQuantity?: number) => minimumQuantity ?? DEFAULT_GROUP_MIN_QUANTITY;

const discountMultiplier = (discountPercent?: number) => 1 - (discountPercent ?? 0) / 100;

// Per-seat is a UI estimate: rounding here can drift a cent from the authoritative total below.
export const computeGroupPerSeatCents = ({
  amountCents,
  discountPercent,
}: {
  amountCents: number;
  discountPercent?: number;
}) => Math.round(amountCents * discountMultiplier(discountPercent));

// Authoritative: matches what Stripe charges (coupon applied at the line-item level, single rounding pass).
// See Group Subscriptions tech spec §3 Q9.
export const computeGroupTotalCents = ({
  amountCents,
  quantity,
  discountPercent,
}: {
  amountCents: number;
  quantity: number;
  discountPercent?: number;
}) => Math.round(amountCents * quantity * discountMultiplier(discountPercent));
